import { Routes } from '@angular/router';

import { MapDemoComponent } from './map-demo.component';

export const mapRoutes: Routes = [
  { path: 'maps', component: MapDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/map/map.routes.ts